import { motion } from "framer-motion";
import { Wallet, Coins, ArrowLeftRight, PartyPopper } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Wallet,
    title: "Get a Phantom Wallet",
    body: "Install Phantom (or Solflare) on mobile or browser. Back up your seed phrase like it’s a treasure map.",
    link: { label: "phantom.com", href: "https://phantom.com" },
  },
  {
    n: "02",
    icon: Coins,
    title: "Load up on SOL",
    body: "Buy SOL on any exchange (Coinbase, Binance, MEXC) and send it to your Phantom wallet address.",
  },
  {
    n: "03",
    icon: ArrowLeftRight,
    title: "Open Pump.fun or Raydium",
    body: "Paste the JetDog contract address into the swap field. Double-check it matches the one on this page.",
    link: { label: "Pump.fun", href: "https://pump.fun/8Bdum5DBYXqqi5BeGej45vKVifELQM7pASUfysLTpump" },
  },
  {
    n: "04",
    icon: PartyPopper,
    title: "Swap SOL for $JETDOG",
    body: "Set slippage 5–10%, confirm in Phantom. Welcome aboard the jetski. Hold tight, paws up.",
  },
];

export const HowToBuy = () => {
  return (
    <section id="how-to-buy" className="section bg-[#07070E]" data-testid="howtobuy-section">
      <div className="mx-auto max-w-6xl">
        <div className="text-left md:text-center">
          <p className="font-accent text-2xl text-[var(--jd-primary)]">no rocket science</p>
          <h2
            className="font-display font-bold text-4xl md:text-6xl uppercase mt-2 neon-title"
            data-testid="howtobuy-title"
          >
            How to Buy
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6 md:gap-8">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.07 }}
                className="gg-panel rounded-2xl p-6 flex gap-5 card-lift"
                data-testid={`howtobuy-step-${i + 1}`}
              >
                <div
                  className="shrink-0 w-16 h-16 rounded-xl flex items-center justify-center font-display font-bold text-2xl gg-terminal text-[var(--jd-secondary)]"
                >
                  {s.n}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 text-[var(--jd-primary)]">
                    <Icon size={20} />
                    <h3 className="font-display font-bold text-lg uppercase text-[var(--jd-text)]">{s.title}</h3>
                  </div>
                  <p className="mt-2 text-sm md:text-base leading-relaxed text-[var(--jd-ocean)]">{s.body}</p>
                  {s.link && (
                    <a
                      href={s.link.href}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-block mt-3 font-display uppercase text-xs text-[var(--jd-accent)] underline decoration-2 underline-offset-4 hover:text-[var(--jd-primary)] transition-colors"
                      data-testid={`howtobuy-step-${i + 1}-link`}
                    >
                      {s.link.label} ↗
                    </a>
                  )}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowToBuy;
